@if (campaign.loading) {
  <mat-dialog-content
    fxLayout="column">
    <div fxLayout="row"
      fxLayoutAlign="start"
      [ngClass]="{'campaign-send-confirmation__mobile-loader-container': campaign.isMobile}">
      <div class="campaign-send-confirmation__loading-wheel"
        [ngClass]="{'campaign-send-confirmation__mobile-loading-wheel': campaign.isMobile}"
        [cfaLoading]="true">
      </div>
    </div>
  </mat-dialog-content>
}
<!-- Show error -->
@if (!campaign.loading && campaign.error) {
  <mat-dialog-content
    fxLayout="column"
    class="campaign-send-confirmation__wrapper"
    [ngClass]="{'campaign-send-confirmation__mobile-wrapper': campaign.isMobile}">
    <ng-container>
      <h3 class="campaign-send-confirmation__heading-text"
        [ngClass]="{'campaign-send-confirmation__mobile-heading-text': campaign.isMobile}">
        {{campaign.headingMessage}}
      </h3>
      <p class="campaign-send-confirmation__sub-text">
        {{campaign.subText}}
      </p>
    </ng-container>
  </mat-dialog-content>
}
<!-- success message -->
@if (!campaign.loading && !campaign.error) {
  <mat-dialog-content
    fxLayout="column"
    class="campaign-send-confirmation__wrapper"
    [ngClass]="{'campaign-send-confirmation__mobile-wrapper': campaign.isMobile}">
    <div>
      <ng-container>
        <h3 class="campaign-send-confirmation__heading-text"
          [ngClass]="{'campaign-send-confirmation__mobile-heading-text': campaign.isMobile}">
          {{campaign.headingMessage}}
        </h3>
        <p class="campaign-send-confirmation__sub-text">
          {{campaign.subText}}
        </p>
      </ng-container>
    </div>
  </mat-dialog-content>
}
@if (!campaign.loading) {
  <mat-dialog-content
    fxLayout="column"
    class="campaign-send-confirmation__wrapper"
    [ngClass]="{'campaign-send-confirmation__mobile-wrapper': campaign.isMobile}">
    <div fxLayout="row"
      fxLayoutAlign="space-around start">
      <div fxFlex="100">
        <div mat-dialog-actions
          class="campaign-send-confirmation__btn-wrapper"
          [ngClass]="{'campaign-send-confirmation__mobile-btn-wrapper': campaign.isMobile}">
          @if (!campaign.error && campaign.actionType !== ActionType.Stop) {
            <button
              mat-raised-button
              class="campaign-send-confirmation__action-btn"
              [ngClass]="{'campaign-send-confirmation__mobile-action-btn': campaign.isMobile}"
              (click)="goToCalendar()">
              View on Calendar
            </button>
          }
          @if (!campaign.error && campaign.actionType === ActionType.Create && !campaign.discover) {
            <button
              mat-raised-button
              class="campaign-send-confirmation__action-btn"
              [ngClass]="{'campaign-send-confirmation__mobile-action-btn': campaign.isMobile}"
              (click)="backToEngage()">
              Back to Engage
            </button>
          }
          @if (campaign.discover || campaign.error) {
            <button
              mat-raised-button
              class="campaign-send-confirmation__action-btn"
              [ngClass]="{'campaign-send-confirmation__mobile-action-btn': campaign.isMobile}"
              (click)="goBack()">
              Go Back
            </button>
          }
        </div>
      </div>
    </div>
  </mat-dialog-content>
}
